var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPropertyProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.49935L10.5 1.66602L18 7.49935V16.666C18 17.108 17.8244 17.532 17.5118 17.8445C17.1993 18.1571 16.7754 18.3327 16.3333 18.3327H4.66667C4.22464 18.3327 3.80072 18.1571 3.48816 17.8445C3.17559 17.532 3 17.108 3 16.666V7.49935Z",
    stroke: "#040407",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5809 11.1105C10.5334 11.1037 10.4725 11.1037 10.4183 11.1105C9.22585 11.0697 8.27734 10.0926 8.27734 8.89163C8.27734 7.66347 9.2665 6.66602 10.4996 6.66602C11.7259 6.66602 12.7218 7.66347 12.7218 8.89163C12.715 10.0926 11.7733 11.0697 10.5809 11.1105Z",
    stroke: "#040407",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8346 14.503C12.9543 15.3307 11.7872 15.8333 10.5013 15.8333C9.21545 15.8333 8.04829 15.3307 7.16797 14.503C7.21742 14.0258 7.51416 13.5586 8.04334 13.1931C9.39843 12.269 11.6141 12.269 12.9593 13.1931C13.4884 13.5586 13.7852 14.0258 13.8346 14.503Z",
    stroke: "#040407",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyProfile);
export default __webpack_public_path__ + "static/media/PropertyProfile.87d955cef07772407007a5c965195d39.svg";
export { ForwardRef as ReactComponent };